__turbopack_context__.v({
  "root": "LabelledInput-module__UmEWKG__root" + " " + __turbopack_context__.i(60951)["labelledStyles"],
});
